function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var fs = require('fs');
var path = require('path');

// The admin payment test writes this exact hash onto many transfers.
// It is not a Mixin transaction hash. The unique index excludes only this value.
var SYNTHETIC_INBOUND_TX_HASH = 'admin-test';
var INBOUND_HASH_INDEX = 'transfers_inbound_tx_hash_uidx';
var transactionTails = new WeakMap();
function isRealInboundHash(hash) {
  var value = String(hash || '').trim();
  return value !== '' && value !== SYNTHETIC_INBOUND_TX_HASH;
}
function isInboundHashConflict(err) {
  var message = String((err === null || err === void 0 ? void 0 : err.message) || err || '');
  return (err === null || err === void 0 ? void 0 : err.code) === 'SQLITE_CONSTRAINT' || /UNIQUE constraint failed/i.test(message) || message.includes(INBOUND_HASH_INDEX);
}
function splitTransfersSql(sql) {
  var marker = '-- inbound-payment-uniqueness';
  var at = String(sql || '').indexOf(marker);
  if (at < 0) {
    return {
      tableSql: sql,
      indexSql: ''
    };
  }
  return {
    tableSql: sql.slice(0, at),
    indexSql: sql.slice(at).replace(/^--.*$/gm, '').trim()
  };
}
var TRANSFER_FIELDS = ['purpose', 'mode', 'payload', 'email', 'request_id', 'requester_publickey', 'recipient_publickey', 'status', 'inbound_ticker', 'inbound_asset_id', 'inbound_chain_id', 'inbound_amount', 'inbound_address', 'inbound_sender', 'inbound_mixin_user_id', 'inbound_confirmations', 'inbound_confirmations_required', 'inbound_tx', 'inbound_tx_sig', 'inbound_tx_hash', 'inbound_tx_id', 'inbound_received_at', 'inbound_block_id', 'inbound_block_hash', 'inbound_longest_chain', 'inbound_confirmation_block_id', 'outbound_ticker', 'outbound_asset_id', 'outbound_chain_id', 'outbound_amount', 'outbound_address', 'outbound_sender', 'outbound_mixin_user_id', 'outbound_confirmations_required', 'outbound_tx', 'outbound_tx_sig', 'outbound_tx_hash', 'outbound_tx_id', 'outbound_sent_at', 'outbound_block_id', 'outbound_block_hash', 'outbound_confirmation_block_id', 'last_error', 'excluded', 'created_at', 'updated_at'];
var Database = /*#__PURE__*/function () {
  function Database(app, mod) {
    _classCallCheck(this, Database);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(Database, [{
    key: "dbname",
    value: function dbname() {
      return this.mod.dbname || this.mod.slug || 'mixin';
    }
  }, {
    key: "query",
    value: function () {
      var _query = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(sql, params) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              return _context.a(2, this.app.storage.queryDatabase(sql, params, this.dbname()));
          }
        }, _callee, this);
      }));
      function query(_x, _x2) {
        return _query.apply(this, arguments);
      }
      return query;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(sql, params) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, this.app.storage.runDatabase(sql, params, this.dbname()));
          }
        }, _callee2, this);
      }));
      function run(_x3, _x4) {
        return _run.apply(this, arguments);
      }
      return run;
    }()
  }, {
    key: "saveCredentials",
    value: function () {
      var _saveCredentials = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(publicKey, ciphertext) {
        var userId,
          rows,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              userId = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : null;
              if (!userId) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return this.run("INSERT INTO accounts (publickey, user_id, ciphertext, created_at)\n         VALUES ($publickey, $user_id, $ciphertext, $created_at)\n         ON CONFLICT(publickey, user_id) DO UPDATE SET ciphertext = excluded.ciphertext", {
                $publickey: publicKey,
                $user_id: userId,
                $ciphertext: ciphertext,
                $created_at: Date.now()
              });
            case 1:
              return _context3.a(2);
            case 2:
              _context3.n = 3;
              return this.getCredentials(publicKey);
            case 3:
              rows = _context3.v;
              if (!rows.length) {
                _context3.n = 5;
                break;
              }
              _context3.n = 4;
              return this.run("UPDATE accounts SET ciphertext = $ciphertext WHERE id = $id", {
                $ciphertext: ciphertext,
                $id: rows[0].id
              });
            case 4:
              return _context3.a(2);
            case 5:
              _context3.n = 6;
              return this.run("INSERT INTO accounts (publickey, user_id, ciphertext, created_at)\n       VALUES ($publickey, '', $ciphertext, $created_at)", {
                $publickey: publicKey,
                $ciphertext: ciphertext,
                $created_at: Date.now()
              });
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function saveCredentials(_x5, _x6) {
        return _saveCredentials.apply(this, arguments);
      }
      return saveCredentials;
    }()
  }, {
    key: "getCredentials",
    value: function () {
      var _getCredentials = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(publicKey) {
        var userId,
          _rows$,
          rows,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              userId = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : null;
              if (!userId) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return this.query("SELECT ciphertext FROM accounts WHERE publickey = $publickey AND user_id = $user_id", {
                $publickey: publicKey,
                $user_id: userId
              });
            case 1:
              rows = _context4.v;
              return _context4.a(2, ((_rows$ = rows[0]) === null || _rows$ === void 0 ? void 0 : _rows$.ciphertext) || null);
            case 2:
              return _context4.a(2, this.query("SELECT id, user_id, ciphertext, created_at\n       FROM accounts\n       WHERE publickey = $publickey\n       ORDER BY created_at ASC, id ASC", {
                $publickey: publicKey
              }));
          }
        }, _callee4, this);
      }));
      function getCredentials(_x7) {
        return _getCredentials.apply(this, arguments);
      }
      return getCredentials;
    }()
  }, {
    key: "insertAddress",
    value: function () {
      var _insertAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref) {
        var mixinUserId, publicKey, assetId, address, createdAt;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              mixinUserId = _ref.mixinUserId, publicKey = _ref.publicKey, assetId = _ref.assetId, address = _ref.address, createdAt = _ref.createdAt;
              _context5.n = 1;
              return this.run("INSERT INTO addresses (mixin_user_id, publickey, asset_id, address, created_at)\n       VALUES ($mixin_user_id, $publickey, $asset_id, $address, $created_at)\n       ON CONFLICT(mixin_user_id, asset_id) DO UPDATE SET\n         publickey = excluded.publickey,\n         address = excluded.address", {
                $mixin_user_id: mixinUserId,
                $publickey: publicKey || '',
                $asset_id: assetId,
                $address: address,
                $created_at: createdAt || Date.now()
              });
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function insertAddress(_x8) {
        return _insertAddress.apply(this, arguments);
      }
      return insertAddress;
    }()
  }, {
    key: "listAddresses",
    value: function () {
      var _listAddresses = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var publicKey,
          key,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              publicKey = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : '';
              key = String(publicKey || '');
              if (key) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, []);
            case 1:
              return _context6.a(2, this.query("SELECT id, mixin_user_id, publickey, asset_id, address, created_at\n       FROM addresses\n       WHERE publickey = $publickey\n       ORDER BY created_at ASC, id ASC", {
                $publickey: key
              }));
          }
        }, _callee6, this);
      }));
      function listAddresses() {
        return _listAddresses.apply(this, arguments);
      }
      return listAddresses;
    }()
  }, {
    key: "listReservedInboundAddresses",
    value: function () {
      var _listReservedInboundAddresses = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var rows;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return this.query("SELECT inbound_address, MIN(created_at) AS created_at\n       FROM transfers\n       WHERE excluded = 0\n         AND inbound_address <> ''\n         AND status IN (\n           'inbound_awaiting',\n           'inbound_broadcast',\n           'inbound_confirmed',\n           'outbound_awaiting',\n           'outbound_broadcast',\n           'treasury_submitted',\n           'treasury_accepted'\n         )\n       GROUP BY inbound_address", {});
            case 1:
              rows = _context7.v;
              return _context7.a(2, (rows || []).map(function (row) {
                return {
                  inbound_address: row.inbound_address,
                  created_at: row.created_at
                };
              }).filter(function (row) {
                return row.inbound_address;
              }));
          }
        }, _callee7, this);
      }));
      function listReservedInboundAddresses() {
        return _listReservedInboundAddresses.apply(this, arguments);
      }
      return listReservedInboundAddresses;
    }()
  }, {
    key: "findAddress",
    value: function () {
      var _findAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _ref2,
          assetId,
          mixinUserId,
          publicKey,
          address,
          filters,
          params,
          rows,
          row,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _ref2 = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {}, assetId = _ref2.assetId, mixinUserId = _ref2.mixinUserId, publicKey = _ref2.publicKey, address = _ref2.address;
              if (assetId) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2, null);
            case 1:
              filters = ['asset_id = $asset_id'];
              params = {
                $asset_id: assetId
              };
              if (mixinUserId) {
                filters.push('mixin_user_id = $mixin_user_id');
                params.$mixin_user_id = mixinUserId;
              }
              if (publicKey) {
                filters.push('publickey = $publickey');
                params.$publickey = publicKey;
              }
              if (address) {
                filters.push('address = $address');
                params.$address = address;
              }
              if (!(filters.length === 1)) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2, null);
            case 2:
              _context8.n = 3;
              return this.query("SELECT * FROM addresses WHERE ".concat(filters.join(' AND '), " ORDER BY created_at DESC LIMIT 1"), params);
            case 3:
              rows = _context8.v;
              row = rows[0];
              if (row) {
                _context8.n = 4;
                break;
              }
              return _context8.a(2, null);
            case 4:
              return _context8.a(2, {
                user_id: row.mixin_user_id,
                address: row.address,
                publickey: row.publickey,
                asset_id: row.asset_id
              });
          }
        }, _callee8, this);
      }));
      function findAddress() {
        return _findAddress.apply(this, arguments);
      }
      return findAddress;
    }()
  }, {
    key: "copyLegacyTables",
    value: function () {
      var _copyLegacyTables = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var accounts, _iterator, _step, row, existing, users, _iterator2, _step2, _row, _existing, _t, _t2;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.n = 1;
              return this.query("SELECT publickey, account_hash\n       FROM mixin_accounts\n       WHERE id IN (SELECT MAX(id) FROM mixin_accounts GROUP BY publickey)", {});
            case 1:
              accounts = _context9.v;
              _iterator = _createForOfIteratorHelper(accounts);
              _context9.p = 2;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context9.n = 7;
                break;
              }
              row = _step.value;
              if (!(!(row !== null && row !== void 0 && row.publickey) || !row.account_hash)) {
                _context9.n = 4;
                break;
              }
              return _context9.a(3, 6);
            case 4:
              _context9.n = 5;
              return this.getCredentials(row.publickey);
            case 5:
              existing = _context9.v;
              if (existing !== null && existing !== void 0 && existing.length) {
                _context9.n = 6;
                break;
              }
              _context9.n = 6;
              return this.saveCredentials(row.publickey, row.account_hash);
            case 6:
              _context9.n = 3;
              break;
            case 7:
              _context9.n = 9;
              break;
            case 8:
              _context9.p = 8;
              _t = _context9.v;
              _iterator.e(_t);
            case 9:
              _context9.p = 9;
              _iterator.f();
              return _context9.f(9);
            case 10:
              _context9.n = 11;
              return this.query("SELECT user_id, address, publickey, asset_id, created_at\n       FROM mixin_users\n       ORDER BY created_at DESC", {});
            case 11:
              users = _context9.v;
              _iterator2 = _createForOfIteratorHelper(users);
              _context9.p = 12;
              _iterator2.s();
            case 13:
              if ((_step2 = _iterator2.n()).done) {
                _context9.n = 18;
                break;
              }
              _row = _step2.value;
              if (!(!(_row !== null && _row !== void 0 && _row.user_id) || !_row.asset_id || !_row.address)) {
                _context9.n = 14;
                break;
              }
              return _context9.a(3, 17);
            case 14:
              _context9.n = 15;
              return this.findAddress({
                assetId: _row.asset_id,
                mixinUserId: _row.user_id
              });
            case 15:
              _existing = _context9.v;
              if (!_existing) {
                _context9.n = 16;
                break;
              }
              return _context9.a(3, 17);
            case 16:
              _context9.n = 17;
              return this.insertAddress({
                mixinUserId: _row.user_id,
                publicKey: _row.publickey,
                assetId: _row.asset_id,
                address: _row.address,
                createdAt: _row.created_at
              });
            case 17:
              _context9.n = 13;
              break;
            case 18:
              _context9.n = 20;
              break;
            case 19:
              _context9.p = 19;
              _t2 = _context9.v;
              _iterator2.e(_t2);
            case 20:
              _context9.p = 20;
              _iterator2.f();
              return _context9.f(20);
            case 21:
              return _context9.a(2);
          }
        }, _callee9, this, [[12, 19, 20, 21], [2, 8, 9, 10]]);
      }));
      function copyLegacyTables() {
        return _copyLegacyTables.apply(this, arguments);
      }
      return copyLegacyTables;
    }()
  }, {
    key: "ensureAccountsSchema",
    value: function () {
      var _ensureAccountsSchema = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var columns;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return this.query("PRAGMA table_info(accounts)", {});
            case 1:
              columns = _context0.v;
              if (columns !== null && columns !== void 0 && columns.length) {
                _context0.n = 2;
                break;
              }
              return _context0.a(2);
            case 2:
              if (!columns.some(function (column) {
                return column.name === 'user_id';
              })) {
                _context0.n = 4;
                break;
              }
              _context0.n = 3;
              return this.run("CREATE UNIQUE INDEX IF NOT EXISTS accounts_publickey_user_uidx\n         ON accounts (publickey, user_id)", {});
            case 3:
              return _context0.a(2);
            case 4:
              _context0.n = 5;
              return this.run("ALTER TABLE accounts RENAME TO accounts_legacy", {});
            case 5:
              _context0.n = 6;
              return this.run("CREATE TABLE accounts (\n        id INTEGER PRIMARY KEY AUTOINCREMENT,\n        publickey TEXT NOT NULL,\n        user_id TEXT NOT NULL DEFAULT '',\n        ciphertext TEXT NOT NULL,\n        created_at INTEGER NOT NULL DEFAULT 0\n      )", {});
            case 6:
              _context0.n = 7;
              return this.run("INSERT INTO accounts (id, publickey, user_id, ciphertext, created_at)\n       SELECT id, publickey, '', ciphertext, created_at FROM accounts_legacy", {});
            case 7:
              _context0.n = 8;
              return this.run("DROP TABLE accounts_legacy", {});
            case 8:
              _context0.n = 9;
              return this.run("CREATE UNIQUE INDEX IF NOT EXISTS accounts_publickey_user_uidx\n       ON accounts (publickey, user_id)", {});
            case 9:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function ensureAccountsSchema() {
        return _ensureAccountsSchema.apply(this, arguments);
      }
      return ensureAccountsSchema;
    }()
  }, {
    key: "ensureTransfersSchema",
    value: function () {
      var _ensureTransfersSchema = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var _defined$;
        var columns, defined, definedSql, sql, tableSql, legacyColumns, freshColumns, shared, present, additions, _i, _additions, _additions$_i, name, definition, _t3, _t4;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return this.query("PRAGMA table_info(transfers)", {});
            case 1:
              columns = _context1.v;
              if (columns !== null && columns !== void 0 && columns.length) {
                _context1.n = 2;
                break;
              }
              return _context1.a(2);
            case 2:
              _context1.n = 3;
              return this.query("SELECT sql FROM sqlite_master WHERE type = 'table' AND name = 'transfers'", {});
            case 3:
              defined = _context1.v;
              definedSql = String(((_defined$ = defined[0]) === null || _defined$ === void 0 ? void 0 : _defined$.sql) || '');
              if (!(!definedSql.includes("'inbound_awaiting'") || !definedSql.includes("'treasury_submitted'"))) {
                _context1.n = 15;
                break;
              }
              _context1.n = 4;
              return this.run("ALTER TABLE transfers RENAME TO transfers_legacy", {});
            case 4:
              sql = fs.readFileSync(path.join(__dirname, '../sql/transfers.sql'), 'utf8');
              tableSql = splitTransfersSql(sql).tableSql;
              if (!this.app.storage.executeDatabase) {
                _context1.n = 6;
                break;
              }
              _context1.n = 5;
              return this.app.storage.executeDatabase(tableSql, this.dbname());
            case 5:
              _context1.n = 7;
              break;
            case 6:
              _context1.n = 7;
              return this.run(tableSql, {});
            case 7:
              _t3 = Set;
              _context1.n = 8;
              return this.query("PRAGMA table_info(transfers_legacy)", {});
            case 8:
              _t4 = _context1.v.map(function (column) {
                return column.name;
              });
              legacyColumns = new _t3(_t4);
              _context1.n = 9;
              return this.query("PRAGMA table_info(transfers)", {});
            case 9:
              freshColumns = _context1.v.map(function (column) {
                return column.name;
              });
              shared = freshColumns.filter(function (name) {
                return name !== 'status' && legacyColumns.has(name);
              });
              if (!shared.length) {
                _context1.n = 10;
                break;
              }
              _context1.n = 10;
              return this.run("INSERT INTO transfers (status, ".concat(shared.join(', '), ")\n           SELECT CASE status\n             WHEN 'awaiting_inbound' THEN 'inbound_awaiting'\n             WHEN 'inbound_pending' THEN 'inbound_broadcast'\n             WHEN 'inbound_observed' THEN 'inbound_broadcast'\n             WHEN 'awaiting_outbound' THEN 'outbound_awaiting'\n             WHEN 'outbound_pending' THEN 'outbound_broadcast'\n             WHEN 'outbound_sent' THEN 'outbound_broadcast'\n             WHEN 'outbound_observed' THEN 'outbound_broadcast'\n             ELSE status\n           END, ").concat(shared.join(', '), "\n           FROM transfers_legacy"), {});
            case 10:
              _context1.n = 11;
              return this.run("DROP TABLE transfers_legacy", {});
            case 11:
              _context1.n = 12;
              return this.ensureInboundPaymentUniqueness();
            case 12:
              _context1.n = 13;
              return this.ensureStoreWithdrawalClaims();
            case 13:
              _context1.n = 14;
              return this.ensureTreasurySchema();
            case 14:
              return _context1.a(2);
            case 15:
              present = new Set(columns.map(function (column) {
                return column.name;
              }));
              additions = [['request_id', "TEXT NOT NULL DEFAULT ''"], ['requester_publickey', "TEXT NOT NULL DEFAULT ''"], ['recipient_publickey', "TEXT NOT NULL DEFAULT ''"], ['inbound_confirmations', 'INTEGER NOT NULL DEFAULT 0'], ['inbound_confirmations_required', 'INTEGER NOT NULL DEFAULT 0'], ['outbound_confirmations_required', 'INTEGER NOT NULL DEFAULT 1'], ['inbound_tx_hash', "TEXT NOT NULL DEFAULT ''"], ['inbound_tx_id', "TEXT NOT NULL DEFAULT ''"], ['outbound_tx_id', "TEXT NOT NULL DEFAULT ''"], ['inbound_confirmation_block_id', 'INTEGER'], ['outbound_confirmation_block_id', 'INTEGER'], ['mode', "TEXT NOT NULL DEFAULT 'automatic' CHECK (mode IN ('automatic', 'manual'))"], ['excluded', 'INTEGER NOT NULL DEFAULT 0']];
              _i = 0, _additions = additions;
            case 16:
              if (!(_i < _additions.length)) {
                _context1.n = 18;
                break;
              }
              _additions$_i = _slicedToArray(_additions[_i], 2), name = _additions$_i[0], definition = _additions$_i[1];
              if (present.has(name)) {
                _context1.n = 17;
                break;
              }
              _context1.n = 17;
              return this.run("ALTER TABLE transfers ADD COLUMN ".concat(name, " ").concat(definition), {});
            case 17:
              _i++;
              _context1.n = 16;
              break;
            case 18:
              _context1.n = 19;
              return this.ensureInboundPaymentUniqueness();
            case 19:
              _context1.n = 20;
              return this.ensureStoreWithdrawalClaims();
            case 20:
              _context1.n = 21;
              return this.ensureTreasurySchema();
            case 21:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function ensureTransfersSchema() {
        return _ensureTransfersSchema.apply(this, arguments);
      }
      return ensureTransfersSchema;
    }()
  }, {
    key: "ensureTreasurySchema",
    value: function () {
      var _ensureTreasurySchema = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var _this$app$storage$ret, _this$app$storage;
        var db, sql;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return (_this$app$storage$ret = (_this$app$storage = this.app.storage).returnDatabaseByName) === null || _this$app$storage$ret === void 0 ? void 0 : _this$app$storage$ret.call(_this$app$storage, this.dbname());
            case 1:
              db = _context10.v;
              if (db !== null && db !== void 0 && db.exec) {
                _context10.n = 2;
                break;
              }
              return _context10.a(2);
            case 2:
              sql = fs.readFileSync(path.join(__dirname, '../sql/treasury.sql'), 'utf8');
              _context10.n = 3;
              return db.exec(sql);
            case 3:
              _context10.n = 4;
              return db.exec("\n      CREATE UNIQUE INDEX IF NOT EXISTS transfers_treasury_request_uidx\n        ON transfers (request_id)\n        WHERE purpose = 'treasury-payout' AND request_id <> '';\n    ");
            case 4:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function ensureTreasurySchema() {
        return _ensureTreasurySchema.apply(this, arguments);
      }
      return ensureTreasurySchema;
    }()
  }, {
    key: "ensureStoreWithdrawalClaims",
    value: function () {
      var _ensureStoreWithdrawalClaims = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var db;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.n = 1;
              return this.app.storage.returnDatabaseByName(this.dbname());
            case 1:
              db = _context11.v;
              if (db) {
                _context11.n = 2;
                break;
              }
              return _context11.a(2);
            case 2:
              _context11.n = 3;
              return db.exec("\n      CREATE TABLE IF NOT EXISTS store_withdrawal_claims (\n        transfer_uuid TEXT PRIMARY KEY,\n        payment_uuid TEXT NOT NULL UNIQUE,\n        request_id TEXT NOT NULL,\n        withdrawal_transfer_id INTEGER NOT NULL\n      );\n      CREATE UNIQUE INDEX IF NOT EXISTS store_withdrawal_request_uidx\n        ON transfers (request_id)\n        WHERE purpose = 'store-withdrawal' AND request_id <> '';\n    ");
            case 3:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function ensureStoreWithdrawalClaims() {
        return _ensureStoreWithdrawalClaims.apply(this, arguments);
      }
      return ensureStoreWithdrawalClaims;
    }()
  }, {
    key: "withImmediateTransaction",
    value: function () {
      var _withImmediateTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(fn) {
        var db, previous, operation;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return this.app.storage.returnDatabaseByName(this.dbname());
            case 1:
              db = _context13.v;
              if (db) {
                _context13.n = 2;
                break;
              }
              throw new Error('Mixin database unavailable');
            case 2:
              previous = transactionTails.get(db) || Promise.resolve();
              operation = previous.then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
                var result, _t5, _t6;
                return _regenerator().w(function (_context12) {
                  while (1) switch (_context12.p = _context12.n) {
                    case 0:
                      _context12.n = 1;
                      return db.exec('BEGIN IMMEDIATE');
                    case 1:
                      _context12.p = 1;
                      _context12.n = 2;
                      return fn(db);
                    case 2:
                      result = _context12.v;
                      _context12.n = 3;
                      return db.exec('COMMIT');
                    case 3:
                      return _context12.a(2, result);
                    case 4:
                      _context12.p = 4;
                      _t5 = _context12.v;
                      _context12.p = 5;
                      _context12.n = 6;
                      return db.exec('ROLLBACK');
                    case 6:
                      _context12.n = 8;
                      break;
                    case 7:
                      _context12.p = 7;
                      _t6 = _context12.v;
                      console.error('Mixin Database: rollback failed', _t6);
                    case 8:
                      throw _t5;
                    case 9:
                      return _context12.a(2);
                  }
                }, _callee12, null, [[5, 7], [1, 4]]);
              })));
              transactionTails.set(db, operation.then(function () {
                return undefined;
              }, function () {
                return undefined;
              }));
              return _context13.a(2, operation);
          }
        }, _callee13, this);
      }));
      function withImmediateTransaction(_x9) {
        return _withImmediateTransaction.apply(this, arguments);
      }
      return withImmediateTransaction;
    }()
  }, {
    key: "recordStoreWithdrawal",
    value: function () {
      var _recordStoreWithdrawal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(record) {
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              _context15.n = 1;
              return this.ensureStoreWithdrawalClaims();
            case 1:
              return _context15.a(2, this.withImmediateTransaction(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(db) {
                  var existing, _require, decimalUnits, backing, requested, _iterator3, _step3, pair, source, row, units, claimed, now, inserted, transferId, _iterator4, _step4, _pair, _t7, _t8;
                  return _regenerator().w(function (_context14) {
                    while (1) switch (_context14.p = _context14.n) {
                      case 0:
                        _context14.n = 1;
                        return db.all("SELECT id, purpose, mode, payload\n         FROM transfers\n         WHERE purpose = 'store-withdrawal' AND request_id = $request\n         LIMIT 1", {
                          $request: record.request_id
                        });
                      case 1:
                        existing = _context14.v;
                        if (!(existing !== null && existing !== void 0 && existing.length)) {
                          _context14.n = 2;
                          break;
                        }
                        return _context14.a(2, {
                          transfer_id: existing[0].id,
                          replayed: true
                        });
                      case 2:
                        _require = require('./store-withdrawal'), decimalUnits = _require.decimalUnits;
                        backing = 0n;
                        requested = decimalUnits(record.withdrawal_amount);
                        if (!(requested == null)) {
                          _context14.n = 3;
                          break;
                        }
                        throw new Error('The withdrawal amount is not valid.');
                      case 3:
                        _iterator3 = _createForOfIteratorHelper(record.pairs);
                        _context14.p = 4;
                        _iterator3.s();
                      case 5:
                        if ((_step3 = _iterator3.n()).done) {
                          _context14.n = 12;
                          break;
                        }
                        pair = _step3.value;
                        _context14.n = 6;
                        return db.all("SELECT id, purpose, inbound_tx_hash, inbound_ticker, inbound_amount, inbound_asset_id\n           FROM transfers\n           WHERE id = $id", {
                          $id: Number(pair.transfer)
                        });
                      case 6:
                        source = _context14.v;
                        row = source === null || source === void 0 ? void 0 : source[0];
                        if (!(!row || row.purpose !== 'store-purchase' || String(row.inbound_tx_hash || '') !== pair.payment)) {
                          _context14.n = 7;
                          break;
                        }
                        throw new Error('A referenced transfer or payment was not found.');
                      case 7:
                        if (!(String(row.inbound_ticker || '').trim().toUpperCase() !== String(record.ticker || '').trim())) {
                          _context14.n = 8;
                          break;
                        }
                        throw new Error('A referenced payment is for a different cryptocurrency.');
                      case 8:
                        units = decimalUnits(row.inbound_amount);
                        if (!(units == null)) {
                          _context14.n = 9;
                          break;
                        }
                        throw new Error('A referenced payment amount is not valid.');
                      case 9:
                        backing += units;
                        _context14.n = 10;
                        return db.all("SELECT request_id FROM store_withdrawal_claims\n           WHERE transfer_uuid = $transfer OR payment_uuid = $payment\n           LIMIT 1", {
                          $transfer: pair.transfer,
                          $payment: pair.payment
                        });
                      case 10:
                        claimed = _context14.v;
                        if (!(claimed !== null && claimed !== void 0 && claimed.length)) {
                          _context14.n = 11;
                          break;
                        }
                        throw new Error('Those proceeds are already reserved for a withdrawal.');
                      case 11:
                        _context14.n = 5;
                        break;
                      case 12:
                        _context14.n = 14;
                        break;
                      case 13:
                        _context14.p = 13;
                        _t7 = _context14.v;
                        _iterator3.e(_t7);
                      case 14:
                        _context14.p = 14;
                        _iterator3.f();
                        return _context14.f(14);
                      case 15:
                        if (!(backing !== requested)) {
                          _context14.n = 16;
                          break;
                        }
                        throw new Error('The withdrawal amount does not match the unspent proceeds.');
                      case 16:
                        now = Date.now();
                        _context14.n = 17;
                        return db.run("INSERT INTO transfers (\n           purpose, mode, payload, request_id, requester_publickey, recipient_publickey,\n           status, inbound_ticker, inbound_amount, inbound_sender, inbound_tx, inbound_tx_sig,\n           outbound_ticker, outbound_amount, outbound_address, outbound_sender,\n           created_at, updated_at\n         ) VALUES (\n           'store-withdrawal', 'manual', $payload, $request_id, $requester, $requester,\n           'other', 'SAITO', $inbound_amount, $inbound_sender, $inbound_tx, $inbound_tx_sig,\n           $outbound_ticker, $outbound_amount, $outbound_address, $outbound_sender,\n           $now, $now\n         )", {
                          $payload: record.payload,
                          $request_id: record.request_id,
                          $requester: record.sender,
                          $inbound_amount: record.saito_amount,
                          $inbound_sender: record.sender,
                          $inbound_tx: record.saito_tx || '',
                          $inbound_tx_sig: record.saito_tx_sig || '',
                          $outbound_ticker: record.ticker,
                          $outbound_amount: record.withdrawal_amount,
                          $outbound_address: record.withdrawal_address,
                          $outbound_sender: record.outbound_sender || '',
                          $now: now
                        });
                      case 17:
                        inserted = _context14.v;
                        transferId = inserted === null || inserted === void 0 ? void 0 : inserted.lastID;
                        if (transferId) {
                          _context14.n = 18;
                          break;
                        }
                        throw new Error('The withdrawal transfer was not recorded.');
                      case 18:
                        _iterator4 = _createForOfIteratorHelper(record.pairs);
                        _context14.p = 19;
                        _iterator4.s();
                      case 20:
                        if ((_step4 = _iterator4.n()).done) {
                          _context14.n = 22;
                          break;
                        }
                        _pair = _step4.value;
                        _context14.n = 21;
                        return db.run("INSERT INTO store_withdrawal_claims (\n             transfer_uuid, payment_uuid, request_id, withdrawal_transfer_id\n           ) VALUES ($transfer, $payment, $request, $transfer_id)", {
                          $transfer: _pair.transfer,
                          $payment: _pair.payment,
                          $request: record.request_id,
                          $transfer_id: transferId
                        });
                      case 21:
                        _context14.n = 20;
                        break;
                      case 22:
                        _context14.n = 24;
                        break;
                      case 23:
                        _context14.p = 23;
                        _t8 = _context14.v;
                        _iterator4.e(_t8);
                      case 24:
                        _context14.p = 24;
                        _iterator4.f();
                        return _context14.f(24);
                      case 25:
                        return _context14.a(2, {
                          transfer_id: transferId,
                          replayed: false
                        });
                    }
                  }, _callee14, null, [[19, 23, 24, 25], [4, 13, 14, 15]]);
                }));
                return function (_x1) {
                  return _ref4.apply(this, arguments);
                };
              }()));
          }
        }, _callee15, this);
      }));
      function recordStoreWithdrawal(_x0) {
        return _recordStoreWithdrawal.apply(this, arguments);
      }
      return recordStoreWithdrawal;
    }()
  }, {
    key: "listStoreWithdrawalsAwaitingInclusion",
    value: function () {
      var _listStoreWithdrawalsAwaitingInclusion = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              return _context16.a(2, this.query("SELECT * FROM transfers\n       WHERE purpose = 'store-withdrawal'\n         AND excluded = 0\n         AND inbound_tx_sig <> ''\n         AND IFNULL(inbound_block_hash, '') = ''\n       ORDER BY id ASC", {}));
          }
        }, _callee16, this);
      }));
      function listStoreWithdrawalsAwaitingInclusion() {
        return _listStoreWithdrawalsAwaitingInclusion.apply(this, arguments);
      }
      return listStoreWithdrawalsAwaitingInclusion;
    }()
  }, {
    key: "listStoreWithdrawalsInBlock",
    value: function () {
      var _listStoreWithdrawalsInBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(blockId, blockHash) {
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              return _context17.a(2, this.query("SELECT * FROM transfers\n       WHERE purpose = 'store-withdrawal'\n         AND excluded = 0\n         AND inbound_block_id = $block_id\n         AND inbound_block_hash = $block_hash\n       ORDER BY id ASC", {
                $block_id: Number(blockId) || 0,
                $block_hash: String(blockHash || '')
              }));
          }
        }, _callee17, this);
      }));
      function listStoreWithdrawalsInBlock(_x10, _x11) {
        return _listStoreWithdrawalsInBlock.apply(this, arguments);
      }
      return listStoreWithdrawalsInBlock;
    }()
  }, {
    key: "duplicateInboundPayments",
    value: function () {
      var _duplicateInboundPayments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
        var rows, grouped, _iterator5, _step5, row, hash;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              _context18.n = 1;
              return this.query("SELECT inbound_tx_hash, id, purpose\n       FROM transfers\n       WHERE inbound_tx_hash <> ''\n         AND inbound_tx_hash <> $synthetic\n         AND inbound_tx_hash IN (\n           SELECT inbound_tx_hash\n           FROM transfers\n           WHERE inbound_tx_hash <> ''\n             AND inbound_tx_hash <> $synthetic\n           GROUP BY inbound_tx_hash\n           HAVING COUNT(*) > 1\n         )\n       ORDER BY inbound_tx_hash ASC, id ASC", {
                $synthetic: SYNTHETIC_INBOUND_TX_HASH
              });
            case 1:
              rows = _context18.v;
              grouped = new Map();
              _iterator5 = _createForOfIteratorHelper(rows || []);
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  row = _step5.value;
                  hash = row.inbound_tx_hash;
                  if (!grouped.has(hash)) {
                    grouped.set(hash, {
                      inbound_tx_hash: hash,
                      transfers: []
                    });
                  }
                  grouped.get(hash).transfers.push({
                    id: row.id,
                    purpose: row.purpose || ''
                  });
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
              return _context18.a(2, _toConsumableArray(grouped.values()));
          }
        }, _callee18, this);
      }));
      function duplicateInboundPayments() {
        return _duplicateInboundPayments.apply(this, arguments);
      }
      return duplicateInboundPayments;
    }()
    /**
     * Create the real-hash unique index only when no existing row already shares
     * one. Conflicting rows are left unchanged for deliberate recovery.
     */
  }, {
    key: "ensureInboundPaymentUniqueness",
    value: function () {
      var _ensureInboundPaymentUniqueness = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
        var conflicts, _iterator6, _step6, conflict, file, indexSql, present;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              _context19.n = 1;
              return this.duplicateInboundPayments();
            case 1:
              conflicts = _context19.v;
              if (!conflicts.length) {
                _context19.n = 2;
                break;
              }
              _iterator6 = _createForOfIteratorHelper(conflicts);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  conflict = _step6.value;
                  console.error('Mixin inbound payment hash is already assigned to more than one transfer; uniqueness index was not created', {
                    inbound_tx_hash: conflict.inbound_tx_hash,
                    transfers: conflict.transfers
                  });
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
              return _context19.a(2, {
                enforced: false,
                conflicts: conflicts
              });
            case 2:
              file = fs.readFileSync(path.join(__dirname, '../sql/transfers.sql'), 'utf8');
              indexSql = splitTransfersSql(file).indexSql;
              if (!indexSql) {
                _context19.n = 3;
                break;
              }
              _context19.n = 3;
              return this.run(indexSql, {});
            case 3:
              _context19.n = 4;
              return this.query("SELECT name FROM sqlite_master WHERE type = 'index' AND name = $name", {
                $name: INBOUND_HASH_INDEX
              });
            case 4:
              present = _context19.v;
              return _context19.a(2, {
                enforced: (present || []).length > 0,
                conflicts: []
              });
          }
        }, _callee19, this);
      }));
      function ensureInboundPaymentUniqueness() {
        return _ensureInboundPaymentUniqueness.apply(this, arguments);
      }
      return ensureInboundPaymentUniqueness;
    }()
  }, {
    key: "claimInboundPayment",
    value: function () {
      var _claimInboundPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(id) {
        var _fields$inbound_tx_ha;
        var fields,
          hash,
          next,
          assignments,
          params,
          _i2,
          _TRANSFER_FIELDS,
          field,
          owners,
          _attempted$,
          owner,
          attempted,
          current,
          _args20 = arguments,
          _t9;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.p = _context20.n) {
            case 0:
              fields = _args20.length > 1 && _args20[1] !== undefined ? _args20[1] : {};
              hash = String((_fields$inbound_tx_ha = fields.inbound_tx_hash) !== null && _fields$inbound_tx_ha !== void 0 ? _fields$inbound_tx_ha : '').trim();
              next = _objectSpread(_objectSpread({}, fields), {}, {
                inbound_tx_hash: hash
              });
              if (isRealInboundHash(hash)) {
                _context20.n = 2;
                break;
              }
              _context20.n = 1;
              return this.updateTransfer(id, next);
            case 1:
              return _context20.a(2, {
                ok: true,
                conflict: null
              });
            case 2:
              assignments = ['updated_at = $updated_at'];
              params = {
                $id: id,
                $owner_id: id,
                $updated_at: Date.now(),
                $claim_hash: hash
              };
              _i2 = 0, _TRANSFER_FIELDS = TRANSFER_FIELDS;
            case 3:
              if (!(_i2 < _TRANSFER_FIELDS.length)) {
                _context20.n = 6;
                break;
              }
              field = _TRANSFER_FIELDS[_i2];
              if (!(field === 'updated_at' || next[field] === undefined)) {
                _context20.n = 4;
                break;
              }
              return _context20.a(3, 5);
            case 4:
              assignments.push("".concat(field, " = $").concat(field));
              params["$".concat(field)] = next[field];
            case 5:
              _i2++;
              _context20.n = 3;
              break;
            case 6:
              _context20.p = 6;
              _context20.n = 7;
              return this.run("UPDATE transfers SET ".concat(assignments.join(', '), "\n         WHERE id = $id\n           AND NOT EXISTS (\n             SELECT 1 FROM transfers AS claimed\n             WHERE claimed.inbound_tx_hash = $claim_hash\n               AND claimed.id <> $owner_id\n           )"), params);
            case 7:
              _context20.n = 9;
              break;
            case 8:
              _context20.p = 8;
              _t9 = _context20.v;
              if (isInboundHashConflict(_t9)) {
                _context20.n = 9;
                break;
              }
              throw _t9;
            case 9:
              _context20.n = 10;
              return this.query("SELECT id, purpose FROM transfers\n       WHERE inbound_tx_hash = $hash AND id <> $id\n       ORDER BY id ASC", {
                $hash: hash,
                $id: id
              });
            case 10:
              owners = _context20.v;
              if (!(owners !== null && owners !== void 0 && owners.length)) {
                _context20.n = 12;
                break;
              }
              owner = owners[0];
              _context20.n = 11;
              return this.query("SELECT id, purpose FROM transfers WHERE id = $id", {
                $id: id
              });
            case 11:
              attempted = _context20.v;
              console.error('Mixin inbound payment already claimed', {
                inbound_tx_hash: hash,
                owner_transfer_id: owner.id,
                owner_purpose: owner.purpose || '',
                attempted_transfer_id: id,
                attempted_purpose: (attempted === null || attempted === void 0 || (_attempted$ = attempted[0]) === null || _attempted$ === void 0 ? void 0 : _attempted$.purpose) || ''
              });
              return _context20.a(2, {
                ok: false,
                conflict: {
                  id: owner.id,
                  purpose: owner.purpose || ''
                }
              });
            case 12:
              _context20.n = 13;
              return this.query("SELECT inbound_tx_hash FROM transfers WHERE id = $id", {
                $id: id
              });
            case 13:
              current = _context20.v;
              if (!(current !== null && current !== void 0 && current[0] && String(current[0].inbound_tx_hash) === hash)) {
                _context20.n = 14;
                break;
              }
              return _context20.a(2, {
                ok: true,
                conflict: null
              });
            case 14:
              throw new Error("Transfer ".concat(id, " could not record inbound payment ").concat(hash));
            case 15:
              return _context20.a(2);
          }
        }, _callee20, this, [[6, 8]]);
      }));
      function claimInboundPayment(_x12) {
        return _claimInboundPayment.apply(this, arguments);
      }
      return claimInboundPayment;
    }()
  }, {
    key: "insertTransfer",
    value: function () {
      var _insertTransfer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(transfer) {
        var columns, values, now, params, _i3, _TRANSFER_FIELDS2, field, result;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              columns = ['created_at', 'updated_at'];
              values = ['$created_at', '$updated_at'];
              now = Date.now();
              params = {
                $created_at: transfer.created_at || now,
                $updated_at: now
              };
              _i3 = 0, _TRANSFER_FIELDS2 = TRANSFER_FIELDS;
            case 1:
              if (!(_i3 < _TRANSFER_FIELDS2.length)) {
                _context21.n = 5;
                break;
              }
              field = _TRANSFER_FIELDS2[_i3];
              if (!(field === 'created_at' || field === 'updated_at')) {
                _context21.n = 2;
                break;
              }
              return _context21.a(3, 4);
            case 2:
              if (!(transfer[field] === undefined)) {
                _context21.n = 3;
                break;
              }
              return _context21.a(3, 4);
            case 3:
              columns.push(field);
              values.push("$".concat(field));
              params["$".concat(field)] = transfer[field];
            case 4:
              _i3++;
              _context21.n = 1;
              break;
            case 5:
              _context21.n = 6;
              return this.run("INSERT INTO transfers (".concat(columns.join(', '), ") VALUES (").concat(values.join(', '), ")"), params);
            case 6:
              result = _context21.v;
              return _context21.a(2, (result === null || result === void 0 ? void 0 : result.lastID) || null);
          }
        }, _callee21, this);
      }));
      function insertTransfer(_x13) {
        return _insertTransfer.apply(this, arguments);
      }
      return insertTransfer;
    }()
  }, {
    key: "updateTransfer",
    value: function () {
      var _updateTransfer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(id, fields) {
        var assignments, params, _i4, _TRANSFER_FIELDS3, field;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              assignments = ['updated_at = $updated_at'];
              params = {
                $id: id,
                $updated_at: Date.now()
              };
              _i4 = 0, _TRANSFER_FIELDS3 = TRANSFER_FIELDS;
            case 1:
              if (!(_i4 < _TRANSFER_FIELDS3.length)) {
                _context22.n = 4;
                break;
              }
              field = _TRANSFER_FIELDS3[_i4];
              if (!(field === 'updated_at' || fields[field] === undefined)) {
                _context22.n = 2;
                break;
              }
              return _context22.a(3, 3);
            case 2:
              assignments.push("".concat(field, " = $").concat(field));
              params["$".concat(field)] = fields[field];
            case 3:
              _i4++;
              _context22.n = 1;
              break;
            case 4:
              _context22.n = 5;
              return this.run("UPDATE transfers SET ".concat(assignments.join(', '), " WHERE id = $id"), params);
            case 5:
              return _context22.a(2);
          }
        }, _callee22, this);
      }));
      function updateTransfer(_x14, _x15) {
        return _updateTransfer.apply(this, arguments);
      }
      return updateTransfer;
    }()
  }, {
    key: "getTransfers",
    value: function () {
      var _getTransfers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
        var criteria,
          filters,
          params,
          _i5,
          _arr,
          field,
          _args23 = arguments;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.n) {
            case 0:
              criteria = _args23.length > 0 && _args23[0] !== undefined ? _args23[0] : {};
              filters = [];
              params = {};
              for (_i5 = 0, _arr = ['id', 'request_id', 'requester_publickey', 'recipient_publickey', 'inbound_ticker', 'inbound_address', 'status', 'purpose', 'mode', 'excluded']; _i5 < _arr.length; _i5++) {
                field = _arr[_i5];
                if (criteria[field] !== undefined && criteria[field] !== null) {
                  filters.push("".concat(field, " = $").concat(field));
                  params["$".concat(field)] = criteria[field];
                }
              }
              if (filters.length) {
                _context23.n = 1;
                break;
              }
              return _context23.a(2, []);
            case 1:
              return _context23.a(2, this.query("SELECT * FROM transfers WHERE ".concat(filters.join(' AND '), " ORDER BY id ASC"), params));
          }
        }, _callee23, this);
      }));
      function getTransfers() {
        return _getTransfers.apply(this, arguments);
      }
      return getTransfers;
    }()
  }, {
    key: "getTransfersPendingInboundBroadcast",
    value: function () {
      var _getTransfersPendingInboundBroadcast = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24() {
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.n) {
            case 0:
              return _context24.a(2, this.query("SELECT * FROM transfers\n       WHERE mode = 'automatic'\n         AND excluded = 0\n         AND status = 'inbound_awaiting'\n       ORDER BY id ASC", {}));
          }
        }, _callee24, this);
      }));
      function getTransfersPendingInboundBroadcast() {
        return _getTransfersPendingInboundBroadcast.apply(this, arguments);
      }
      return getTransfersPendingInboundBroadcast;
    }()
  }, {
    key: "getTransfersPendingInboundConfirmed",
    value: function () {
      var _getTransfersPendingInboundConfirmed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25() {
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              return _context25.a(2, this.query("SELECT * FROM transfers\n       WHERE mode = 'automatic'\n         AND excluded = 0\n         AND status = 'inbound_broadcast'\n         AND inbound_tx_hash <> ''\n         AND inbound_confirmations >= inbound_confirmations_required\n       ORDER BY id ASC", {}));
          }
        }, _callee25, this);
      }));
      function getTransfersPendingInboundConfirmed() {
        return _getTransfersPendingInboundConfirmed.apply(this, arguments);
      }
      return getTransfersPendingInboundConfirmed;
    }()
  }, {
    key: "getTransfersPendingOutboundAwaiting",
    value: function () {
      var _getTransfersPendingOutboundAwaiting = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(currentBlockId) {
        return _regenerator().w(function (_context26) {
          while (1) switch (_context26.n) {
            case 0:
              return _context26.a(2, this.query("SELECT * FROM transfers\n       WHERE mode = 'automatic'\n         AND excluded = 0\n         AND status = 'inbound_confirmed'\n         AND outbound_tx_sig = ''\n         AND inbound_confirmation_block_id IS NOT NULL\n         AND inbound_confirmation_block_id <= $current_block_id\n       ORDER BY id ASC", {
                $current_block_id: currentBlockId
              }));
          }
        }, _callee26, this);
      }));
      function getTransfersPendingOutboundAwaiting(_x16) {
        return _getTransfersPendingOutboundAwaiting.apply(this, arguments);
      }
      return getTransfersPendingOutboundAwaiting;
    }()
  }, {
    key: "listAdminTransfers",
    value: function () {
      var _listAdminTransfers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27() {
        var _counted$;
        var _ref5,
          _ref5$search,
          search,
          _ref5$page,
          page,
          _ref5$purpose,
          purpose,
          pageSize,
          term,
          selected,
          params,
          where,
          clauses,
          counted,
          total,
          pageCount,
          requested,
          current,
          rows,
          _args27 = arguments;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.n) {
            case 0:
              _ref5 = _args27.length > 0 && _args27[0] !== undefined ? _args27[0] : {}, _ref5$search = _ref5.search, search = _ref5$search === void 0 ? '' : _ref5$search, _ref5$page = _ref5.page, page = _ref5$page === void 0 ? 1 : _ref5$page, _ref5$purpose = _ref5.purpose, purpose = _ref5$purpose === void 0 ? '' : _ref5$purpose;
              pageSize = 20;
              term = String(search || '').trim();
              selected = ['migration', 'buysaito'].includes(purpose) ? purpose : '';
              params = {};
              where = 'excluded = 0';
              if (selected) {
                where += ' AND purpose = $purpose';
                params.$purpose = selected;
              }
              if (!term) {
                where += " AND status IN (\n        'inbound_awaiting',\n        'inbound_broadcast',\n        'inbound_confirmed',\n        'outbound_awaiting',\n        'outbound_broadcast',\n        'treasury_submitted',\n        'treasury_accepted',\n        'treasury_rejected'\n      )";
              } else {
                params.$q = term;
                clauses = ['requester_publickey = $q', 'recipient_publickey = $q', 'publickey = $q', 'inbound_address = $q', 'inbound_sender = $q', 'outbound_address = $q', 'outbound_sender = $q'];
                if (/^0x[a-fA-F0-9]{40}$/i.test(term)) {
                  params.$ql = term.toLowerCase();
                  clauses.push('lower(inbound_address) = $ql', 'lower(inbound_sender) = $ql', 'lower(outbound_address) = $ql', 'lower(outbound_sender) = $ql');
                }
                where += " AND (".concat(clauses.join(' OR '), ")");
              }
              _context27.n = 1;
              return this.query("SELECT COUNT(*) AS total FROM transfers WHERE ".concat(where), params);
            case 1:
              counted = _context27.v;
              total = Number((counted === null || counted === void 0 || (_counted$ = counted[0]) === null || _counted$ === void 0 ? void 0 : _counted$.total) || 0);
              pageCount = Math.max(1, Math.ceil(total / pageSize));
              requested = Number(page);
              current = Number.isInteger(requested) && requested > 0 ? Math.min(requested, pageCount) : 1;
              _context27.n = 2;
              return this.query("SELECT * FROM transfers\n       WHERE ".concat(where, "\n       ORDER BY created_at DESC, id DESC\n       LIMIT $limit OFFSET $offset"), _objectSpread(_objectSpread({}, params), {}, {
                $limit: pageSize,
                $offset: (current - 1) * pageSize
              }));
            case 2:
              rows = _context27.v;
              return _context27.a(2, {
                rows: rows || [],
                total: total,
                page: current,
                page_size: pageSize
              });
          }
        }, _callee27, this);
      }));
      function listAdminTransfers() {
        return _listAdminTransfers.apply(this, arguments);
      }
      return listAdminTransfers;
    }()
  }, {
    key: "getTransfersPendingTreasurySubmission",
    value: function () {
      var _getTransfersPendingTreasurySubmission = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28() {
        return _regenerator().w(function (_context28) {
          while (1) switch (_context28.n) {
            case 0:
              return _context28.a(2, this.query("SELECT * FROM transfers\n       WHERE excluded = 0\n         AND status = 'treasury_submitted'\n       ORDER BY id ASC", {}));
          }
        }, _callee28, this);
      }));
      function getTransfersPendingTreasurySubmission() {
        return _getTransfersPendingTreasurySubmission.apply(this, arguments);
      }
      return getTransfersPendingTreasurySubmission;
    }()
  }, {
    key: "findLocalTreasury",
    value: function () {
      var _findLocalTreasury = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(sourceTransferId) {
        var rows;
        return _regenerator().w(function (_context29) {
          while (1) switch (_context29.n) {
            case 0:
              _context29.n = 1;
              return this.query("SELECT * FROM treasury\n       WHERE origin = 'local' AND source_transfer_id = $source\n       LIMIT 1", {
                $source: Number(sourceTransferId)
              });
            case 1:
              rows = _context29.v;
              return _context29.a(2, (rows === null || rows === void 0 ? void 0 : rows[0]) || null);
          }
        }, _callee29, this);
      }));
      function findLocalTreasury(_x17) {
        return _findLocalTreasury.apply(this, arguments);
      }
      return findLocalTreasury;
    }()
  }, {
    key: "findTreasuryByTransfer",
    value: function () {
      var _findTreasuryByTransfer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(transferId) {
        var rows;
        return _regenerator().w(function (_context30) {
          while (1) switch (_context30.n) {
            case 0:
              _context30.n = 1;
              return this.query("SELECT * FROM treasury\n       WHERE transfer_id = $id\n       ORDER BY id ASC\n       LIMIT 1", {
                $id: Number(transferId)
              });
            case 1:
              rows = _context30.v;
              return _context30.a(2, (rows === null || rows === void 0 ? void 0 : rows[0]) || null);
          }
        }, _callee30, this);
      }));
      function findTreasuryByTransfer(_x18) {
        return _findTreasuryByTransfer.apply(this, arguments);
      }
      return findTreasuryByTransfer;
    }()
  }, {
    key: "updateTreasury",
    value: function () {
      var _updateTreasury = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(id, fields) {
        var assignments, params, _i6, _arr2, field;
        return _regenerator().w(function (_context31) {
          while (1) switch (_context31.n) {
            case 0:
              assignments = ['updated_at = $updated_at'];
              params = {
                $id: id,
                $updated_at: Date.now()
              };
              for (_i6 = 0, _arr2 = ['status', 'last_error', 'remote_transfer_id', 'transfer_id', 'request_tx', 'request_tx_sig', 'request_payload']; _i6 < _arr2.length; _i6++) {
                field = _arr2[_i6];
                if (fields[field] !== undefined) {
                  assignments.push("".concat(field, " = $").concat(field));
                  params["$".concat(field)] = fields[field];
                }
              }
              _context31.n = 1;
              return this.run("UPDATE treasury SET ".concat(assignments.join(', '), " WHERE id = $id"), params);
            case 1:
              return _context31.a(2);
          }
        }, _callee31, this);
      }));
      function updateTreasury(_x19, _x20) {
        return _updateTreasury.apply(this, arguments);
      }
      return updateTreasury;
    }()
  }, {
    key: "saveLocalTreasuryRequest",
    value: function () {
      var _saveLocalTreasuryRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33(record) {
        return _regenerator().w(function (_context33) {
          while (1) switch (_context33.n) {
            case 0:
              _context33.n = 1;
              return this.ensureTreasurySchema();
            case 1:
              return _context33.a(2, this.withImmediateTransaction(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32(db) {
                  var existing, now, inserted, saved;
                  return _regenerator().w(function (_context32) {
                    while (1) switch (_context32.n) {
                      case 0:
                        _context32.n = 1;
                        return db.all("SELECT * FROM treasury\n         WHERE origin = 'local' AND source_transfer_id = $source\n         LIMIT 1", {
                          $source: record.source_transfer_id
                        });
                      case 1:
                        existing = _context32.v;
                        if (!(existing !== null && existing !== void 0 && existing.length)) {
                          _context32.n = 2;
                          break;
                        }
                        return _context32.a(2, existing[0]);
                      case 2:
                        now = Date.now();
                        _context32.n = 3;
                        return db.run("INSERT INTO treasury (\n           origin, requester_publickey, source_transfer_id, request_tx, request_tx_sig,\n           request_payload, transfer_id, status, last_error, created_at, updated_at\n         ) VALUES (\n           'local', $requester, $source, $tx, $sig, $payload, $transfer, 'pending', '', $now, $now\n         )", {
                          $requester: record.requester_publickey,
                          $source: record.source_transfer_id,
                          $tx: record.request_tx,
                          $sig: record.request_tx_sig,
                          $payload: record.request_payload,
                          $transfer: record.transfer_id,
                          $now: now
                        });
                      case 3:
                        inserted = _context32.v;
                        if (inserted !== null && inserted !== void 0 && inserted.lastID) {
                          _context32.n = 4;
                          break;
                        }
                        throw new Error('The treasury request was not recorded.');
                      case 4:
                        _context32.n = 5;
                        return db.all("SELECT * FROM treasury WHERE id = $id", {
                          $id: inserted.lastID
                        });
                      case 5:
                        saved = _context32.v;
                        return _context32.a(2, saved[0]);
                    }
                  }, _callee32);
                }));
                return function (_x22) {
                  return _ref6.apply(this, arguments);
                };
              }()));
          }
        }, _callee33, this);
      }));
      function saveLocalTreasuryRequest(_x21) {
        return _saveLocalTreasuryRequest.apply(this, arguments);
      }
      return saveLocalTreasuryRequest;
    }()
  }, {
    key: "recordRemoteTreasuryPayout",
    value: function () {
      var _recordRemoteTreasuryPayout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee35(record) {
        var _t0;
        return _regenerator().w(function (_context35) {
          while (1) switch (_context35.p = _context35.n) {
            case 0:
              _context35.n = 1;
              return this.ensureTreasurySchema();
            case 1:
              _context35.p = 1;
              _context35.n = 2;
              return this.withImmediateTransaction(/*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee34(db) {
                  var existing, audit, _transfers, now, inserted, transferId, auditInsert, transfers, audits;
                  return _regenerator().w(function (_context34) {
                    while (1) switch (_context34.n) {
                      case 0:
                        _context34.n = 1;
                        return db.all("SELECT * FROM treasury\n           WHERE origin = 'remote'\n             AND requester_publickey = $requester\n             AND source_transfer_id = $source\n           LIMIT 1", {
                          $requester: record.requester_publickey,
                          $source: record.source_transfer_id
                        });
                      case 1:
                        existing = _context34.v;
                        if (!(existing !== null && existing !== void 0 && existing.length)) {
                          _context34.n = 4;
                          break;
                        }
                        audit = existing[0];
                        if (!(audit.request_tx_sig !== record.request_tx_sig || audit.request_payload !== record.request_payload)) {
                          _context34.n = 2;
                          break;
                        }
                        return _context34.a(2, {
                          conflict: true,
                          treasury: audit
                        });
                      case 2:
                        _context34.n = 3;
                        return db.all("SELECT * FROM transfers WHERE id = $id", {
                          $id: audit.transfer_id
                        });
                      case 3:
                        _transfers = _context34.v;
                        return _context34.a(2, {
                          replayed: true,
                          treasury: audit,
                          transfer: (_transfers === null || _transfers === void 0 ? void 0 : _transfers[0]) || null
                        });
                      case 4:
                        now = Date.now();
                        _context34.n = 5;
                        return db.run("INSERT INTO transfers (\n             purpose, mode, payload, request_id, requester_publickey, recipient_publickey,\n             status, inbound_ticker, inbound_amount, inbound_tx_hash, inbound_confirmation_block_id,\n             outbound_ticker, outbound_amount, outbound_address, excluded, created_at, updated_at\n           ) VALUES (\n             'treasury-payout', 'automatic', $payload, $request_id, $requester, $recipient,\n             'inbound_confirmed', $inbound_ticker, $inbound_amount, $inbound_hash, 0,\n             'SAITO', $outbound_amount, $outbound_address, 0, $now, $now\n           )", {
                          $payload: record.payload || '',
                          $request_id: record.request_id,
                          $requester: record.requester_publickey,
                          $recipient: record.recipient_publickey,
                          $inbound_ticker: record.inbound_ticker || '',
                          $inbound_amount: record.inbound_amount || '',
                          $inbound_hash: record.inbound_tx_hash || '',
                          $outbound_amount: record.outbound_amount,
                          $outbound_address: record.recipient_publickey,
                          $now: now
                        });
                      case 5:
                        inserted = _context34.v;
                        transferId = inserted === null || inserted === void 0 ? void 0 : inserted.lastID;
                        if (transferId) {
                          _context34.n = 6;
                          break;
                        }
                        throw new Error('The treasury transfer was not recorded.');
                      case 6:
                        _context34.n = 7;
                        return db.run("INSERT INTO treasury (\n             origin, requester_publickey, source_transfer_id, request_tx, request_tx_sig,\n             request_payload, transfer_id, status, last_error, created_at, updated_at\n           ) VALUES (\n             'remote', $requester, $source, $tx, $sig, $payload, $transfer, 'accepted', '', $now, $now\n           )", {
                          $requester: record.requester_publickey,
                          $source: record.source_transfer_id,
                          $tx: record.request_tx,
                          $sig: record.request_tx_sig,
                          $payload: record.request_payload,
                          $transfer: transferId,
                          $now: now
                        });
                      case 7:
                        auditInsert = _context34.v;
                        if (auditInsert !== null && auditInsert !== void 0 && auditInsert.lastID) {
                          _context34.n = 8;
                          break;
                        }
                        throw new Error('The treasury audit row was not recorded.');
                      case 8:
                        _context34.n = 9;
                        return db.all("SELECT * FROM transfers WHERE id = $id", {
                          $id: transferId
                        });
                      case 9:
                        transfers = _context34.v;
                        _context34.n = 10;
                        return db.all("SELECT * FROM treasury WHERE id = $id", {
                          $id: auditInsert.lastID
                        });
                      case 10:
                        audits = _context34.v;
                        return _context34.a(2, {
                          replayed: false,
                          treasury: audits[0],
                          transfer: transfers[0]
                        });
                    }
                  }, _callee34);
                }));
                return function (_x24) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 2:
              return _context35.a(2, _context35.v);
            case 3:
              _context35.p = 3;
              _t0 = _context35.v;
              if (!isInboundHashConflict(_t0)) {
                _context35.n = 4;
                break;
              }
              return _context35.a(2, {
                rejected: true,
                reason: 'That inbound payment is already assigned to a transfer.'
              });
            case 4:
              throw _t0;
            case 5:
              return _context35.a(2);
          }
        }, _callee35, this, [[1, 3]]);
      }));
      function recordRemoteTreasuryPayout(_x23) {
        return _recordRemoteTreasuryPayout.apply(this, arguments);
      }
      return recordRemoteTreasuryPayout;
    }()
  }, {
    key: "getTransfersPendingOutboundBroadcast",
    value: function () {
      var _getTransfersPendingOutboundBroadcast = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee36() {
        return _regenerator().w(function (_context36) {
          while (1) switch (_context36.n) {
            case 0:
              return _context36.a(2, this.query("SELECT * FROM transfers\n       WHERE status = 'outbound_awaiting'\n         AND outbound_tx_sig <> ''\n       ORDER BY id ASC", {}));
          }
        }, _callee36, this);
      }));
      function getTransfersPendingOutboundBroadcast() {
        return _getTransfersPendingOutboundBroadcast.apply(this, arguments);
      }
      return getTransfersPendingOutboundBroadcast;
    }()
  }, {
    key: "getTransfersPendingOutboundConfirmed",
    value: function () {
      var _getTransfersPendingOutboundConfirmed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee37(currentBlockId) {
        return _regenerator().w(function (_context37) {
          while (1) switch (_context37.n) {
            case 0:
              return _context37.a(2, this.query("SELECT * FROM transfers\n       WHERE status = 'outbound_broadcast'\n         AND outbound_block_hash <> ''\n         AND outbound_confirmation_block_id IS NOT NULL\n         AND outbound_confirmation_block_id <= $current_block_id\n       ORDER BY id ASC", {
                $current_block_id: currentBlockId
              }));
          }
        }, _callee37, this);
      }));
      function getTransfersPendingOutboundConfirmed(_x25) {
        return _getTransfersPendingOutboundConfirmed.apply(this, arguments);
      }
      return getTransfersPendingOutboundConfirmed;
    }()
  }]);
}();
module.exports = Database;
module.exports.SYNTHETIC_INBOUND_TX_HASH = SYNTHETIC_INBOUND_TX_HASH;